/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListEvents200Response,
  ShowEvent200Response,
  UpdateEventRequest,
} from '../models/index';
import {
    ListEvents200ResponseFromJSON,
    ListEvents200ResponseToJSON,
    ShowEvent200ResponseFromJSON,
    ShowEvent200ResponseToJSON,
    UpdateEventRequestFromJSON,
    UpdateEventRequestToJSON,
} from '../models/index';

export interface CreateEventRequest {
    title: string;
    type: string;
    startsAt: string;
    locationName: string;
    description?: string | null;
    endsAt?: string | null;
    city?: string | null;
    country?: string | null;
    lat?: number | null;
    lng?: number | null;
    maxParticipants?: number | null;
    photos?: Array<Blob>;
}

export interface DeleteEventRequest {
    id: number;
}

export interface ShowEventRequest {
    id: number;
}

export interface UpdateEventOperationRequest {
    id: number;
    updateEventRequest?: UpdateEventRequest;
}

/**
 * EventsApi - interface
 * 
 * @export
 * @interface EventsApiInterface
 */
export interface EventsApiInterface {
    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * @summary Create event
     * @param {string} title Must not be greater than 255 characters.
     * @param {string} type 
     * @param {string} startsAt Must be a valid date.
     * @param {string} locationName Must not be greater than 255 characters.
     * @param {string} [description] 
     * @param {string} [endsAt] Must be a valid date. Must be a date after or equal to &lt;code&gt;starts_at&lt;/code&gt;.
     * @param {string} [city] Must not be greater than 255 characters.
     * @param {string} [country] Must not be greater than 255 characters.
     * @param {number} [lat] Must be between -90 and 90.
     * @param {number} [lng] Must be between -180 and 180.
     * @param {number} [maxParticipants] Must be at least 1.
     * @param {Array<Blob>} [photos] Must be an image. Must not be greater than 10240 kilobytes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    createEventRaw(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * Create event
     */
    createEvent(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete event
     * @param {number} id The ID of the event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    deleteEventRaw(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Delete event
     */
    deleteEvent(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    listEventsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEvents200Response>>;

    /**
     * 
     * List events
     */
    listEvents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEvents200Response>;

    /**
     * 
     * @summary Show event
     * @param {number} id The ID of the event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    showEventRaw(requestParameters: ShowEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowEvent200Response>>;

    /**
     * 
     * Show event
     */
    showEvent(requestParameters: ShowEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowEvent200Response>;

    /**
     * 
     * @summary Update event
     * @param {number} id The ID of the event.
     * @param {UpdateEventRequest} [updateEventRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    updateEventRaw(requestParameters: UpdateEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Update event
     */
    updateEvent(requestParameters: UpdateEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI implements EventsApiInterface {

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * Create event
     */
    async createEventRaw(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['title'] == null) {
            throw new runtime.RequiredError(
                'title',
                'Required parameter "title" was null or undefined when calling createEvent().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling createEvent().'
            );
        }

        if (requestParameters['startsAt'] == null) {
            throw new runtime.RequiredError(
                'startsAt',
                'Required parameter "startsAt" was null or undefined when calling createEvent().'
            );
        }

        if (requestParameters['locationName'] == null) {
            throw new runtime.RequiredError(
                'locationName',
                'Required parameter "locationName" was null or undefined when calling createEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['title'] != null) {
            formParams.append('title', requestParameters['title'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }

        if (requestParameters['type'] != null) {
            formParams.append('type', requestParameters['type'] as any);
        }

        if (requestParameters['startsAt'] != null) {
            formParams.append('starts_at', requestParameters['startsAt'] as any);
        }

        if (requestParameters['endsAt'] != null) {
            formParams.append('ends_at', requestParameters['endsAt'] as any);
        }

        if (requestParameters['locationName'] != null) {
            formParams.append('location_name', requestParameters['locationName'] as any);
        }

        if (requestParameters['city'] != null) {
            formParams.append('city', requestParameters['city'] as any);
        }

        if (requestParameters['country'] != null) {
            formParams.append('country', requestParameters['country'] as any);
        }

        if (requestParameters['lat'] != null) {
            formParams.append('lat', requestParameters['lat'] as any);
        }

        if (requestParameters['lng'] != null) {
            formParams.append('lng', requestParameters['lng'] as any);
        }

        if (requestParameters['maxParticipants'] != null) {
            formParams.append('max_participants', requestParameters['maxParticipants'] as any);
        }

        if (requestParameters['photos'] != null) {
            requestParameters['photos'].forEach((element) => {
                formParams.append('photos', element as any);
            })
        }


        let urlPath = `/api/v1/events`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * Create event
     */
    async createEvent(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createEventRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Delete event
     */
    async deleteEventRaw(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/events/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Delete event
     */
    async deleteEvent(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * List events
     */
    async listEventsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEvents200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/events`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListEvents200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List events
     */
    async listEvents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEvents200Response> {
        const response = await this.listEventsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * Show event
     */
    async showEventRaw(requestParameters: ShowEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowEvent200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/events/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowEvent200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Show event
     */
    async showEvent(requestParameters: ShowEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowEvent200Response> {
        const response = await this.showEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Update event
     */
    async updateEventRaw(requestParameters: UpdateEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/events/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEventRequestToJSON(requestParameters['updateEventRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Update event
     */
    async updateEvent(requestParameters: UpdateEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEventRaw(requestParameters, initOverrides);
    }

}
